import React from 'react';
import classnames from 'classnames';
import Label from 'shared/components/Label';
import Tooltip from 'shared/components/Tooltip';
import TextAreaInput from './TextAreaInput';

const TextAreaComponent = (props) => {
  const {
    name,
    inputId,
    label,
    tooltip,
    required,
    errorMessage,
    inputClassName,
    className,
    children,
  } = props;

  return (
    <div className={classnames('form-group', className)}>
      <Label htmlFor={inputId} label={label} required={required}>
        <Tooltip id={`tooltip-${name}`} title={tooltip} />
      </Label>
      <TextAreaInput
        {...props}
        className={classnames(errorMessage && 'error', inputClassName)} />
      <span className="error mt-1">
        {errorMessage}
      </span>
      {children}
    </div>
  );
};

TextAreaComponent.defaultProps = {
  label: '',
  required: false,
};

export default TextAreaComponent;
